<template>
    <div class="tabs">
        <div :class="['tab', activeTab === 'network' ? 'active' : '']" @click="OpenTab('network')">
            <common-icon name="users" size="tiny"></common-icon>
            <p>{{ $t('modals.patient_profile.profile.request.tabs.medmatch') }}</p>
        </div>
        <div :class="['tab', activeTab === 'email' ? 'active' : '']" @click="OpenTab('email')">
            <common-icon name="email" size="tiny"></common-icon>
            <p>{{ $t('modals.patient_profile.profile.request.tabs.request') }}</p>
        </div>
        <div :class="['tab', activeTab === 'hipaa' ? 'active' : '']" @click="OpenTab('hipaa')">
            <common-icon name="insure" size="tiny"></common-icon>
            <p>{{ $t('modals.patient_profile.profile.request.tabs.hippa') }}</p>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeTab: 'network',
            }
        },
        methods: {
            OpenTab(name) {
                this.$emit('toggle', name)
                this.activeTab = name
            },
        },
    }
</script>
